import {Component} from 'react';
import PropTypes from 'prop-types';

export default class Uid extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
  };
  state = {uid: 0};
  componentDidMount() {
    this.setState({uid: Uid.counter++});
  }

  static counter = 0;

  render() {
    return this.props.children(this.state.uid);
  }
}
